import { Card, CardContent, Grid, List, ListItem, Typography, Button, styled } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";
import { viewPath } from "../../utils/routeUtils";

const StyledCard = styled(Card)(() => ({
  marginBottom: "1rem",
}));

interface FavouritesListItemProps {
  id: string;
  taskType: string;
  title: string;
  created: string;
  modelType: string;
  description?: string;
  producedBy?: string;
  inversionType?: string;
}
const FavouritesListItem: React.FC<FavouritesListItemProps> = ({
  id,
  title,
  created,
  modelType,
  description,
  producedBy,
  taskType,
}: FavouritesListItemProps) => {
  return (
    <StyledCard>
      <CardContent>
        <Typography>
          <strong>
            {taskType}: {id} &nbsp;&nbsp;
          </strong>
          <Button color="inherit" component={Link} to={viewPath(id)} variant="contained">
            more
          </Button>
        </Typography>
        <Grid container spacing={1}>
          <Grid columns={5}>
            <List dense>
              <ListItem disableGutters={true}>
                <Typography>
                  <strong>Produced by General Task:</strong> <Link to={viewPath(producedBy)}>{producedBy}</Link>
                </Typography>
              </ListItem>
              <ListItem disableGutters={true}>
                <Typography>
                  <strong>Title</strong> {title}
                </Typography>
              </ListItem>
            </List>
          </Grid>
          <Grid columns={5}>
            <List dense>
              <ListItem disableGutters={true}>
                <Typography>
                  <strong>Created</strong> {created}
                </Typography>
              </ListItem>
              <ListItem disableGutters={true}>
                <Typography>
                  <strong>Model Type</strong> {modelType}
                </Typography>
              </ListItem>
            </List>
          </Grid>
        </Grid>
        {description && (
          <Typography>
            <strong>Description: </strong> {description}
          </Typography>
        )}
      </CardContent>
    </StyledCard>
  );
};

export default FavouritesListItem;
